export default {
  'open-menu': 'Abra o menu',
  'close-menu': 'Fechar',
  'editorial-staff': 'Redação',
  about: 'Sobre nós',
  shopLink: 'Um mundo de possibilidades',
}
